// src/components/AddedToBagToast.js
import React from "react";
import { useCart } from "../context/CartContext";

function AddedToBagToast() {
  const { addedToast, lang } = useCart();

  if (!addedToast) return null;

  const message =
    lang === "EN"
      ? `“${addedToast.nameEN}” added to your bag`
      : `“${addedToast.nameAR}” أُضيفت إلى سلة المشتريات`;

  return (
    <div
      className="
        fixed
        top-[90px]
        left-1/2
        -translate-x-1/2
        z-[99999]

        px-5 py-3
        rounded-full
        text-[13px] md:text-sm
        font-semibold
        text-white

        bg-black/90
        border border-[rgba(46,150,42,0.45)]
        shadow-[0_0_25px_rgba(46,150,42,0.45)]
        backdrop-blur-md

        flex items-center gap-3

        animate-toastSlideFade
      "
    >
      {/* CHECK ICON */}
      <span className="text-[#2E5A2A] text-lg">✔</span>

      {/* MESSAGE */}
      <span className="whitespace-nowrap">{message}</span>

      {/* RADAR DOT */}
      <span
        className="
          w-2 h-2 rounded-full
          bg-[#2E5A2A]
          animate-ping
        "
      ></span>
    </div>
  );
}

export default AddedToBagToast;
